import {PerformanceLogger} from '../performance';
import percentile from 'percentile';
import {LOG_DOC_TYPE, LOG_TYPE} from './const';
import {ENVIRONMENT_LEVEL} from '@/Constant';

const CONST = {
    publishStart: 'publishStart',
    publishEnd: 'publishEnd',
    measureId: 'x_rlkb_document_publish',
    publishDelay: 'publishDelay',
};

const PUBLISH_ERROR_ID_MAP = {
    [LOG_DOC_TYPE.doc]: '80001.2.33',
    [LOG_DOC_TYPE.sheet]: '80001.8.59',
    [LOG_DOC_TYPE.ppt]: '80001.8.87',
    [LOG_DOC_TYPE.datasheet]: '80001.2.138',
};

export class Publish {

    key = 'Publish';

    logger: PerformanceLogger;

    publishTime: number = 0;

    constructor(logger: PerformanceLogger) {
        this.logger = logger;
    }

    logWeb =({id, data}: {id: string, data?: any}) => {
        const logger = this.logger;
        const logLevel = logger?.logLevel || '';
        if ([ENVIRONMENT_LEVEL.online, ENVIRONMENT_LEVEL.gray, ENVIRONMENT_LEVEL.qa].includes(logLevel)) {
            const opVersion = logger?.getOpVersionInfo();
            logger.feLogger({
                id,
                data: {
                    ...data,
                    opVersion,
                },
            });
        }
    };

    // 文档发布
    publish(isCardView: boolean) {
        if (performance.clearMarks) {
            performance.clearMarks(CONST.publishStart);
            performance.clearMarks(CONST.publishEnd);
        }
        const {buffer, logLevel = ''} = this.logger;
        performance.mark(CONST.publishStart);
        if (logLevel !== ENVIRONMENT_LEVEL.online) {
            buffer.add(`${this.key}${CONST.publishStart}`, performance.now());
        }
        this.logWeb({
            id: '80001.8.35',
            data: {
                docType: LOG_DOC_TYPE.doc,
                viewType: isCardView ? 'card' : 'doc',
            },
        });
        this.publishTime = performance.now();
    }

    // 表格发布次数
    sheetPublishTimes(times: number) {
        this.logWeb({
            id: '80001.8.58', // 发布次数埋点id，表格和文档不复用
            data: {
                publishCount: times,
                docType: LOG_DOC_TYPE.sheet,
            },
        });
    }

    // ppt发布次数
    pptPublishTimes(times: number) {
        this.logWeb({
            id: '80001.8.88', // ppt发布次数埋点id
            data: {
                publishCount: times,
                docType: LOG_DOC_TYPE.ppt,
            },
        });
    }

    // 数据表发布次数
    datasheetPublishTimes(times: number) {
        this.logWeb({
            id: '80001.2.139',
            data: {
                publishCount: times,
                docType: LOG_DOC_TYPE.datasheet,
            },
        });
    }

    publishSuccess(isCardView: boolean) {
        const {buffer, logLevel = ''} = this.logger;
        const performanceNow = performance.now();
        performance.mark(CONST.publishEnd);
        performance.measure(CONST.measureId, CONST.publishStart, CONST.publishEnd);
        if (logLevel !== ENVIRONMENT_LEVEL.online) {
            buffer.add(`${this.key}${CONST.publishEnd}`, performanceNow);
        }
        this.logWeb({
            id: '80001.8.36',
            data: {
                delay: performanceNow - this.publishTime,
                viewType: isCardView ? 'card' : 'doc',
            },
        });
    }

    onlyPublishSuccess() {
        const logId = '80001.2.263';
        this.logWeb({
            id: logId,
        });
    }

    publishError(docType: string, error?: Error) {
        const logId = PUBLISH_ERROR_ID_MAP[docType] || '80001.2.33';
        this.logWeb({
            id: logId,
            data: {
                error,
                docType, // 用于区分文档表格和PPT
            },
        });
    }

    getDelayData() {
        const perfs = performance.getEntriesByName(CONST.measureId);
        return perfs.map(perf => {
            return perf.duration;
        });
    }


    getData() {
        const {buffer} = this.logger;
        const startKey = `${this.key}${CONST.publishStart}`;
        const endKey = `${this.key}${CONST.publishStart}`;
        const delayData = this.getDelayData();
        if (!delayData.length) {
            return null;
        }
        const calculatedData = percentile(
            [80, 85, 90, 95],
            delayData
        );
        const data = calculatedData as number[];
        const startArr = buffer.get(startKey);
        const successArr = buffer.get(startKey);
        performance.clearMeasures(CONST.measureId);
        return {
            logType: LOG_TYPE.period,
            type: this.key,
            delay: {
                '80': data[0],
                '85': data[1],
                '90': data[2],
                '95': data[3],
            },
            successRatio: successArr / startArr,
            origin: {
                [`${startKey}`]: startArr,
                [`${endKey}`]: successArr,
                [`${CONST.publishDelay}`]: delayData,
            },
        };
    }
}
